/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { TextField, Box, Typography, Button, InputAdornment, Tooltip, IconButton, FormControl, FormControlLabel, RadioGroup, Radio, FormLabel } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { checkViewPermission, checkComponentPermission, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import { ListTable } from './ListTable.js'
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { customNumberValidation, emptyValidation } from "../../../../../helpers/validation";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import { NavLink } from "react-router-dom";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";

const ActivityPrefixCounter = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);

    const { history } = props;
    const [visible, setVisible] = useState(false);

    const timeoutRef = useRef(null);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [view, setView] = useState(false);
    const [error, setError] = useState({});
    const [form, setForm] = useState({});
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [search, setSearch] = useState('');
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const prevSearch = usePrevious(search);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();

    // const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {

    // }

    const handleOpen = () => {
        setVisible(true);
        setForm({});
        setError({});
    };

    const handleClose = () => {
        setVisible(false);
        setForm({});
        setError({});
    };

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Activity Prefix Counter', history, 'Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const loadTasks = () => {
        dispatchFilter(sortBy, sortOrder);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onView = (data, v) => {
        handleOpen();
        setForm(data);
        setView(v);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast.error(editError.error.message);
        }
    }, [editDetails, editError]);


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    }

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ id: { like: '%' + search.trim() + '%' } });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'activity-counters',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyCounter = customNumberValidation('Counter', form?.counter);
        let pre = true;
        let emptyPrefix = emptyValidation('Custom Prefix', form?.customPrefix);
        if (form?.prefixType === 'CUSTOM' && !emptyPrefix?.isValid) {
            pre = false;
        }
        if (emptyCounter?.isValid && pre) {
            let a = { ...form };
            delete a.business; delete a.activityPrefix;
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "activity-counters",
                title: "Activity Prefixes Counter",
                id: form?.id,
                details: a
            });
        } else {
            setError({
                ...error,
                counter: emptyCounter?.errors,
                customPrefix: emptyPrefix?.errors
            })
        }
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Activity Prefix Counter', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Activity Prefix Counter'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Activity Prefix Counter', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                fullWidth
                                                onChange={(e) => setSearch(e.target.value)}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                {/* <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Activity Prefix Counter', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('ActivityPrefixCounter'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Activity Prefix Counter', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col> */}
                            </Row>
                            <ListTable
                                businessDetails={businessDetails}
                                onView={(data, v) => onView(data, v)}
                                onEdit={(data, v) => onView(data, v)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`View Activity Counter`}
                    width={"495px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => handleSubmit(e)}>
                            <div className={classes.customFormFlex}>
                                <Row type="flex" gutter={40}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Module</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.activityPrefix?.feature?.module?.module ?? '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.feature, 'MuiInputLabel-shrink', classes.fonSize13)}>Feature</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.activityPrefix?.feature?.featureName ?? '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Business Prefix</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{businessDetails?.sequencePrefix ? `${businessDetails?.sequencePrefix}${form?.prefix}${(parseInt(form?.counter) + 1).toLocaleString('en-US', { minimumIntegerDigits: 5, useGrouping: false })}` : '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Prefix</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.prefix}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Starting Number</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{`${form?.prefix}00001`}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        {
                                            view ? <><Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sequence Number</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{`${form?.prefix}${(parseInt(form?.counter) + 1).toLocaleString('en-US', { minimumIntegerDigits: 5, useGrouping: false })}`}</Typography></> : <>
                                                {
                                                    (form?.prefix === 'CI' || form?.prefix === 'CN' || form?.prefix === 'VI') ? <TextField autoComplete='one-time-code'
                                                        label={["Sequence Number ", <span key={"Sequence Number"} className={classes.colorRedRequired}> *</span>]}
                                                        fullWidth
                                                        type={"number"}
                                                        value={form?.counter}
                                                        error={error?.counter && true}
                                                        helperText={error?.counter}
                                                        variant={'standard'}
                                                        name={'counter'}
                                                        className={clsx(classes.margin20t)}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            },
                                                            endAdornment: (
                                                                <InputAdornment className={classes.iconorangecolor} position="end">
                                                                    <Tooltip tabIndex={-1}
                                                                        classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                                        title={'If you would like the system to start the Invoice new number as "00001" THEN enter the number as "00000"'} arrow placement="top"
                                                                        className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                                        <IconButton>
                                                                            <Image src={infoMarkIcon} preview={false} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                    /> : <><Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Next Number</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{(parseInt(form?.counter) + 1).toLocaleString('en-US', { minimumIntegerDigits: 5, useGrouping: false })}</Typography></>
                                                }
                                            </>
                                        }
                                    </Col>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        {
                                            view ? <><Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Prefix Type</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(form?.prefixType)}</Typography></> : <>
                                                <FormControl
                                                    tabIndex={-1}
                                                    className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                                    variant={'standard'}
                                                    fullWidth>
                                                    <FormLabel className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Prefix Type</FormLabel>
                                                    <RadioGroup row
                                                        defaultValue="ACTIVE"
                                                        aria-labelledby="demo-customized-radios"
                                                        name="prefixType"
                                                        value={form?.prefixType || false}
                                                        onChange={(e) => changeHandler(e)}>
                                                        <FormControlLabel value="AUTOMATIC" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Automatic" />
                                                        <FormControlLabel value="MANUAL" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Manual" />
                                                        <FormControlLabel value="CUSTOM" control={<Radio
                                                            checkedIcon={<UnSelectedIcon />}
                                                            icon={<SelectedIcon />}
                                                        />} label="Custom" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </>
                                        }
                                    </Col>
                                    {
                                        form?.prefixType === 'CUSTOM' && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            {
                                                view ? <><Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Custom Prefix</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customPrefix}</Typography></> : <TextField autoComplete='one-time-code'
                                                        label={["Custom Prefix ", <span key={"Custom Prefix"} className={classes.colorRedRequired}> *</span>]}
                                                        fullWidth
                                                        value={form?.customPrefix}
                                                        error={error?.customPrefix ? true : false}
                                                        helperText={error?.customPrefix}
                                                        variant={'standard'}
                                                        name={'customPrefix'}
                                                        className={clsx(classes.margin20t)}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColorCustom,
                                                        }}
                                                        onChange={(e) => changeHandler(e)}
                                                />
                                            }
                                        </Col>
                                    }
                                </Row>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                {
                                    view && (form?.prefix === 'CI' || form?.prefix === 'CN') ? <Button
                                        key="edit"
                                        color='primary'
                                        variant="contained"
                                        onClick={() => setView(false)}
                                        className={clsx(classes.modalBtn)}>
                                        Edit
                                    </Button> : <>
                                        {
                                            (form?.prefix === 'CI' || form?.prefix === 'CN') && <Button
                                                key="save"
                                                type='submit'
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>Update & Close
                                            </Button>
                                        }
                                    </>
                                }
                            </div>
                        </Box>
                    }
                />
            </div>
            {/* <CustomModal
                title={'Reset Feature'}
                visible={resetModal}
                onClose={() => setResetModal(false)}
                text={`Do you want to reset ${form?.activityPrefix?.feature?.featureName} Number`}
                yesButton={'Yes'}
                noButton={'Cancel'}
                onOpen={() => handleReset()}
                loading={editLoader}
            /> */}
        </React.Fragment>
    )
}
export default ActivityPrefixCounter